import MarsCentraBookEot from '../assets/fonts/MarsCentra-v1-WEBFONTS/MarsCentra-Book.eot'
import MarsCentraBookWoff from '../assets/fonts/MarsCentra-v1-WEBFONTS/MarsCentra-Book.woff'
import MarsCentraBookWoff2 from '../assets/fonts/MarsCentra-v1-WEBFONTS/MarsCentra-Book.woff2'
import MarsCentraBookSvg from '../assets/fonts/MarsCentra-v1-WEBFONTS/MarsCentra-Book.svg'

import MarsCentraBoldEot from '../assets/fonts/MarsCentra-v1-WEBFONTS/MarsCentra-Bold.eot'
import MarsCentraBoldWoff from '../assets/fonts/MarsCentra-v1-WEBFONTS/MarsCentra-Bold.woff'
import MarsCentraBoldWoff2 from '../assets/fonts/MarsCentra-v1-WEBFONTS/MarsCentra-Bold.woff2'
import MarsCentraBoldSvg from '../assets/fonts/MarsCentra-v1-WEBFONTS/MarsCentra-Bold.svg'

import MarsCentraExtraboldEot from '../assets/fonts/MarsCentra-v1-WEBFONTS/MarsCentra-Extrabold.eot'
import MarsCentraExtraboldWoff from '../assets/fonts/MarsCentra-v1-WEBFONTS/MarsCentra-Extrabold.woff'
import MarsCentraExtraboldWoff2 from '../assets/fonts/MarsCentra-v1-WEBFONTS/MarsCentra-Extrabold.woff2'
import MarsCentraExtraboldSvg from '../assets/fonts/MarsCentra-v1-WEBFONTS/MarsCentra-Extrabold.svg'

const MarsCentraBook = {
  fontFamily: 'MarsCentra',
  fontStyle: 'normal',
  fontWeight: 400,
  src: `local('MarsCentra-Regular'), 
  url(${MarsCentraBookEot}),
  url(${MarsCentraBookWoff}) format('woff'),
  url(${MarsCentraBookWoff2}) format('woff2')
  url(${MarsCentraBookSvg}) format('svg'),
  `,
  unicodeRange: `U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF`,

};

const MarsCentraBold = {
  fontFamily: 'MarsCentra',
  fontStyle: 'normal',
  fontWeight: 700,
  src: `local('MarsCentra-Bold'), 
  url(${MarsCentraBoldEot}),
  url(${MarsCentraBoldWoff}) format('woff'),
  url(${MarsCentraBoldWoff2}) format('woff2')
  url(${MarsCentraBoldSvg}) format('svg'),
  `,
  unicodeRange: `U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF`,

};

const MarsCentraExtrabold = {
  fontFamily: 'MarsCentra',
  fontStyle: 'normal',
  fontWeight: 1000,
  src: `local('MarsCentra-Extrabold'), 
  url(${MarsCentraExtraboldEot}),
  url(${MarsCentraExtraboldWoff}) format('woff'),
  url(${MarsCentraExtraboldWoff2}) format('woff2')
  url(${MarsCentraExtraboldSvg}) format('svg'),
  `,
  unicodeRange: `U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF`,

};


export default [MarsCentraBook, MarsCentraBold, MarsCentraExtrabold]